import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { setThemeTransitionOrigin } from '@/composables/useDarkMode'
import ToggleSwitch from 'primevue/toggleswitch'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeSwitcher ',
  props: {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const darkTheme = _useModel<boolean>(__props, "modelValue")

function captureOrigin(e: MouseEvent) {
  setThemeTransitionOrigin(`${e.clientX}px`, `${e.clientY}px`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onClickCapture: captureOrigin }, [
    _createVNode(_unref(ToggleSwitch), {
      modelValue: darkTheme.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((darkTheme).value = $event)),
      "aria-label": "Alternar tema"
    }, {
      handle: _withCtx(({ checked }) => [
        _createElementVNode("i", {
          class: _normalizeClass(['pi !text-xs', { 'pi-moon': checked, 'pi-sun': !checked }])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 32))
}
}

})